import React from "react";
import { PiHouse, PiHouseFill } from "react-icons/pi";
import NavButton from "./NavButton";
interface LearnButtonProps {
  isActive: boolean;
  onClick: () => void;
}
const HomeButton: React.FC<LearnButtonProps> = ({ isActive, onClick }) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      icon={<PiHouse className="h-full w-auto" />}
      fillIcon={<PiHouseFill className="h-full w-auto" />}
      text="Home"
    />
  );
};
export default HomeButton;
